import {createGiftCartReconciler,createShopifyGiftCartAdapter} from './reconcile-gift-cart.js?v=oregano-once-v1';

const node=document.getElementById('PilotGiftCartConfig');
let config;
try {config=JSON.parse(node?.textContent||'null');} catch {config=null;}
// A metafield must be enabled explicitly after real discount/cart verification.
if(config?.active&&config.discountVerified===true&&!window.pilotGiftCart) {
  const source='pilot-gift-cart';
  const adapter=createShopifyGiftCartAdapter(window.fetch.bind(window),window.Shopify?.routes?.root||'/');
  const reconcile=createGiftCartReconciler(adapter,config);
  let pending=null,dirty=false,checkoutWaiting=false;
  const releasedForms=new WeakSet();
  const report=error=>{
    document.dispatchEvent(new CustomEvent('pilot:gift-error',{detail:{message:error.message}}));
    let notice=document.getElementById('PilotGiftCartError');
    if(!notice){notice=document.createElement('p');notice.id='PilotGiftCartError';notice.setAttribute('role','alert');document.querySelector('.cart__checkout-button')?.before(notice);}
    notice.textContent=config.errorMessage||'We could not update your free gift. Please try again before checking out.';
  };
  const run=()=>{
    if(pending){dirty=true;return pending;}
    if(!navigator.locks){report(new Error('Gift synchronization requires cross-tab locking'));return Promise.resolve({status:'error'});}
    pending=navigator.locks.request('pilot-gift-cart',async()=>{
      let result;
      do {
        dirty=false;
        result=await reconcile();
        if(result.status!=='settled')throw new Error('Cart changed during gift synchronization');
        if(result.changed)document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:result.cart,sourceId:source,data:{source,itemCount:result.cart.item_count}}}));
      } while(dirty);
      document.getElementById('PilotGiftCartError')?.remove();
      return result;
    }).catch(error=>{report(error);return {status:'error'};}).finally(()=>{pending=null;});
    return pending;
  };
  window.pilotGiftCart={reconcile:run};
  document.addEventListener('cart:update',event=>{
    if(event.detail?.data?.source!==source&&!event.detail?.data?.didError)run();
  });
  document.addEventListener('submit',async event=>{
    const form=event.target,button=event.submitter;
    if(button?.name!=='checkout')return;
    if(releasedForms.has(form)){releasedForms.delete(form);return;}
    event.preventDefault();
    if(checkoutWaiting)return;
    checkoutWaiting=true;
    const formId=form.id;
    button.setAttribute('aria-busy','true');
    try {
      const result=await run();
      if(result?.status!=='settled')return;
      // Cart renderers can replace the original form while gifts are updated.
      const currentForm=form.isConnected?form:document.getElementById(formId);
      const currentButton=[...document.querySelectorAll('[name="checkout"]')].find(e=>e.form===currentForm);
      if(!currentForm||!currentButton){report(new Error('Checkout form refreshed; retry required'));return;}
      releasedForms.add(currentForm);
      currentForm.requestSubmit(currentButton);
    } finally {checkoutWaiting=false;button.removeAttribute('aria-busy');}
  },true);
  window.addEventListener('pageshow',run);
  run();
}
